import { getStorageItem } from "./utils/storage";

export default async (page, id) => {
  const userid = getStorageItem("userid");
  if (page == "searchresults") {
    id = id.replace(/^#/, "");
  }
  const final_endpoint = `https://api.thisbit.ch/analytics/${page}/${id}/${userid}`;
  //const final_endpoint = `http://localhost:8888/analytics/${page}/${id}/${userid}`;
  console.log(final_endpoint);
  let response = await fetch(final_endpoint);
  let data = await response.json();
  console.log(data);
  return data;
};
